/**
 * useDownloadableModules — Hook to fetch which stage_gate_config modules
 * have schema-section mappings and are therefore downloadable as XLSX.
 *
 * Returns:
 *   downloadableModules : Set<string>  module codes (e.g. "A.1.1", "B.2.1")
 *   subType             : string       resolved sub_type (e.g. "commercial")
 *   ready               : boolean
 */
import { useEffect, useState } from "react";
import api from "./api";

export default function useDownloadableModules(projectId) {
  const [data, setData] = useState({
    downloadableModules: new Set(),
    subType: null,
    ready: false,
  });

  useEffect(() => {
    if (!projectId) return;
    let cancel = false;
    api.get(`/projects/${projectId}/template/modules`)
       .then((r) => {
         if (cancel) return;
         const set = new Set();
         for (const m of r.data?.modules || []) {
           if (m.downloadable) set.add(m.module_code);
         }
         setData({
           downloadableModules: set,
           subType: r.data?.sub_type || null,
           ready: true,
         });
       })
       .catch(() => {
         if (!cancel) setData({
           downloadableModules: new Set(),
           subType: null,
           ready: true,
         });
       });
    return () => { cancel = true; };
  }, [projectId]);

  return data;
}
